var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.49963C10.9323 4.49963 9.25 6.18188 9.25 8.24963C9.25 10.3174 10.9323 11.9996 13 11.9996C15.0677 11.9996 16.75 10.3174 16.75 8.24963C16.75 6.18188 15.0677 4.49963 13 4.49963ZM13 10.4996C11.7595 10.4996 10.75 9.49013 10.75 8.24963C10.75 7.00913 11.7595 5.99963 13 5.99963C14.2405 5.99963 15.25 7.00913 15.25 8.24963C15.25 9.49013 14.2405 10.4996 13 10.4996ZM19.75 18.7496V17.9996C19.75 15.1054 17.3942 12.7496 14.5 12.7496H11.5C8.605 12.7496 6.25 15.1054 6.25 17.9996V18.7496H7.75V17.9996C7.75 15.9319 9.43225 14.2496 11.5 14.2496H14.5C16.5677 14.2496 18.25 15.9319 18.25 17.9996V18.7496H19.75Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic-profile.dfc7687cc71cc24588e4f20246059ff5.svg";
export { ForwardRef as ReactComponent };